import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import {
  FirebaseNotificationIntialValues,
  FirebaseNotificationValidationSchema,
} from "../../constant";
import { useMutateCreateFirebaseNotification } from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import InputWithLabel from "../../../../Components/InputWithLabel";
import TextArea from "../../../../Components/TextArea";
import { BackButton } from "../../../../Components";
import SaveButton from "../../../../Components/SaveButton";
import Select from "react-select";
import { getNotificationDayOptions, getPhaseOptions } from "../../../../Utils/Helper";
import PhaseSelect from "../../../../Components/PhaseSelect";

const AddFirebaseNotifications = () => {
  const navigate = useNavigate();
  const addFirebaseNotificationsApi = useMutateCreateFirebaseNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitAddNotification = (values) => {
    const reqData = {
      title: values?.title,
      message: values?.message,
      day: values?.day,
      phase: values?.phase,
    };

    setIsLoading(true);
    addFirebaseNotificationsApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || "Added Successfully.");
        navigate("/admin/push-notifications");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Add Push Notifications</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Add Push Notification</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/push-notifications" />
                      </div>
                    </div>
                  </div>

                  {/* Form Section */}
                  <section className="section-border">
                    <Formik
                      initialValues={{ ...FirebaseNotificationIntialValues, phase: "" }}
                      validationSchema={FirebaseNotificationValidationSchema}
                      validateOnChange
                      onSubmit={handleSubmitAddNotification}
                    >
                      {(formik) => (
                        <Form>
                          <div className="row">
                            {/* Row 1: Phase and Day */}
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Phase</label><span className='text-danger'> *</span>
                                <PhaseSelect
                                  value={formik.values.phase}
                                  onChange={(phase) => {
                                    formik.setFieldValue("phase", phase),
                                      formik.setFieldValue("day", null)
                                  }}
                                  onBlur={() => formik.setFieldTouched("phase", true)}
                                  isClearable={false}
                                  styles={{
                                    container: (s) => ({ ...s, width: "100%" }),
                                    control: (s, state) => ({
                                      ...s,
                                      border: state.isFocused ? "2px solid #AD5ADC" : "2px solid #00000061",
                                      boxShadow: state.isFocused ? "0 0 0 1px #AD5ADC" : "none",
                                      borderRadius: 10,
                                      minHeight: 40,
                                      paddingLeft: 6,
                                    }),
                                  }}
                                />
                              </div>
                              <ErrorMessage name="phase" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Select Day</label><span className='text-danger'> *</span>
                                <Select
                                  options={formik.values.phase ? getNotificationDayOptions(formik.values.phase) : []}
                                  placeholder={formik.values.phase ? "Select Day" : "Select Phase first"}
                                  value={(formik.values.phase ? getNotificationDayOptions(formik.values.phase) : [])
                                    .find((o) => o.value === formik.values.day) || null}
                                  onChange={(option) => {
                                    formik.setFieldValue("day", option ? option.value : null);
                                  }}
                                  isDisabled={!formik.values.phase}
                                  isClearable={false}
                                />
                              </div>
                              <ErrorMessage name="day" component="div" className="text-danger" />
                            </div>

                            {/* Row 2: Title and Message */}
                            <div className="col-md-6 mt-3">
                              <Field
                                Label="Title"
                                type="text"
                                name="title"
                                placeholder="Enter Title"
                                component={InputWithLabel}
                                style={{ color: "#1e2022" }}
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <Field
                                Label="Message"
                                name="message"
                                placeholder="Enter Message"
                                component={TextArea}
                                style={{ color: "#1e2022" }}
                              />
                            </div>
                          </div>

                          <SaveButton loading={isLoading} />
                        </Form>
                      )}
                    </Formik>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddFirebaseNotifications;
